import { BaseRouteService } from "core/services";

class FacilityOrderTemplateRouteService extends BaseRouteService {
	constructor() {
		super("facility-order-templates");
	}

	find(filter) {
		return super.find(`${this.base}/{?searchQuery,page,rpp,sort,embed,fields,facilityOrderId,patientId,inActive,nonCurrent,itemCategoryIds,adjustNextRunDate,importDetailStatusId,newFlowStatusId,newFlowInsuranceStatusId,newFlowInsuranceStatusIds,newFlowUSIntakeStatusIds,inactiveReasonId,isReviewed,isClinicalReviewed,isDischarged,patientSize,skipPatientSize,ids,facilityId,includeInDocReqEmail,templateId,facilityOrderIdToExclude,dosDateFrom,dosDateTo,subCategoryName,masterPatientId,notCurrentTube,hasIncludeNotCurrentTube}`, filter);
	}

	validatePatientHeightAndWeight(resource) {
		return super.find(`${this.base}/validate-patient-height-and-weight/{?facilityOrderId,patientId}`, resource);
	}

	get(id, options) {
		return super.get(`${this.base}/{id}{?embed,fields}`, id, options);
	}

	getFacilityOrderTemplateValidation(id, options) {
		return super.get(`${this.base}/get-facility-order-template-validation/{id}{?embed}`, id, options);
	}

	isReviewedFacilityOrderAsync(facilityOrderId) {
		return super.get(`${this.base}/is-reviewed/{facilityOrderId}`, null, facilityOrderId);
	}

	isNewTemplate(resource) {
		return super.find(`${this.base}/is-new-patient/{?facilityOrderId,patientId}`, resource);
	}

	getMedicalNecessityFormReportUrl(id) {
		return super.get(`${this.base}/get-medical-necessity-form-report/{id}`, id, null);
	}

	getStandardWrittenOrderReportUrl(id) {
		return super.get(`${this.base}/get-standard-written-order-report/{id}`, id, null);
	}

	addTrackingCase(facilityOrderTemplateId) {
		return super.create(`${this.base}/{facilityOrderTemplateId}/add-tracking-case`, { facilityOrderTemplateId });
	}

	createBySubCategory() {
		return super.create(`${this.base}/create-by-sub-category`);
	}

	createTemplateAndItemsNewFlow() {
		return super.create(`${this.base}/create-template-and-items-new-flow`);
	}

	createMasterPatientTemplateBySubCategory() {
		return super.create(`${this.base}/create-master-patient-template-by-sub-category`);
	}

	getTemplateNavigation(filter) {
		return super.find(`${this.base}/template-navigation/{?facilityOrderId,patientId,itemCategoryIds,inActive,nonCurrent}`, filter);
	}

	oldDownload(filter) {
		return super.find(this.base + '/old-download/{?searchQuery,sort,facilityOrderId}', filter);
	}

	download(filter) {
		return super.find(this.base + '/download/{?searchQuery,sort,facilityOrderId}', filter);
	}

	downloadNewFlow(filter) {
		return super.find(this.base + '/download-new-flow/{?searchQuery,sort,facilityOrderId}', filter);
	}

	downloadNewFlowCsv(filter) {
		return super.find(this.base + '/download-new-flow-csv/{?searchQuery,sort,facilityOrderId}', filter);
	}

	updateTemplateAndItems(resource) {
		return super.update(`${this.base}/{id}/update-template-and-items`, resource);
	}

	updateNewFlowClinicalTemplate(resource) {
		return super.update(`${this.base}/{id}/update-new-flow-clinical-template`, resource);
	}

	updateNewFlowUSIntakeTemplate(resource) {
		return super.update(`${this.base}/{id}/update-new-flow-usintake-template`, resource);
	}

	updatePortalNote(resource) {
		return super.update(`${this.base}/{id}/update-portal-note`, resource);
	}

	updatePriorAuthNeeded(resource) {
		return super.update(`${this.base}/{id}/update-prior-auth-needed`, resource);
	}

	activateFacilityOrderTemplate(resource) {
		return super.update(`${this.base}/activate-template`, resource);
	}

	importFacilityOrderTemplate(resource) {
		return super.update(`${this.base}/{facilityOrderTemplateId}/import`, resource);
	}

	reloadFacilityOrderTemplate(resource) {
		return super.update(`${this.base}/{id}/reload`, resource);
	}

	validateFacilityOrderTemplate(resource) {
		return super.update(`${this.base}/{id}/validate`, resource);
	}

	updateInactiveReason(resource) {
		return super.update(`${this.base}/update-inactive-reason`, resource);
	}

	deleteNewTemplate(id) {
		return super.delete(`${this.base}/new/{id}`, { id });
	}

	validateItems(id, options) {
		return super.get(`${this.base}/validate-items/{id}{?embed}`, id, options);
	}

	update(resource) {
		return super.update(this.base + '/{id}', resource);
	}

	batchUpdate(resource) {
		return super.batchUpdate(this.base + '/batch', resource);
	}

	reloadTemplates(resource) {
		return super.update(`${this.base}/reload-templates`, resource);
	}

	isTemplateCategoryLinkedWithDoNotSupplyAreaOfCareOnFacility(resource) {
		return super.get(`${this.base}/check-is-template-category-linked-with-do-not-supply-area-of-care/{facilityOrderId}{?itemCategoryId,patientId}`, null, resource);
	}

	setDoNotSupply(resource) {
		return super.update(`${this.base}/set-do-not-supply/{?id}`, resource);
	}

	updateMissingProductNote(resource) {
		return super.update(`${this.base}/{id}/update-missing-product-note/{?missingProductNote}`, resource);
	}

	updateMissingProduct(resource) {
		return super.update(`${this.base}/update-missing-product/{?id}`, resource);
	}

	resolveMissingProductNote(resource) {
		return super.update(`${this.base}/resolve-missing-product-note/{?id}`, resource);
	}

	changeTemplateStatus(resource) {
		return super.update(`${this.base}/change-status`, resource);
	}

	createMasterPatientTemplateBySubCategoryNewFlow() {
		return super.create(`${this.base}/create-master-patient-template-by-sub-category-new-flow`);
	}

	updateFacilityOrderTemplateIntakeStatuses(resource) {
		return super.update(`${this.base}/{facilityOrderId}/update-intake-template-statuses`, resource);
	}

	findReplacementItems(filter) {
		return super.find(`${this.base}/get-replacement-items/{?facilityOrderId,searchQuery,productId,unitOfMeasureIdToExclude}`, filter);
	}

	isReviewedFacilityOrderNewFlowAsync(facilityOrderId) {
		return super.get(`${this.base}/is-reviewed-new-flow/{facilityOrderId}`, null, facilityOrderId);
	}

	isIVPoleItemNeeded(resource) {
		return super.find(`${this.base}/is-iv-pole-item-needed/{?id,isReferenceBillable}`, resource);
	}

	updateInvoiceNote(facilityOrderTemplateId, note) {
		return super.update(`${this.base}/invoice-note/${facilityOrderTemplateId}?note=${note}`, note);
	}

	updateCustomOrderingDoctor(resource) {
		return super.update(`${this.base}/update-custom-ordering-doctor`, resource);
	}

	createNotCurrentTubeExtraSupplyTemplate(resources) {
		return super.batchCreate(this.base + '/create-not-current-tube-extra-supply-template', resources);
	}

	importCheck(id, actionName) {
		return super.get(`${this.base}/import-check/{id}/${actionName}`, id, null);
	}

	hasBackorderedItem(facilityOrderId) {
		return super.get(`${this.base}/has-backordered-item/{facilityOrderId}`, null, facilityOrderId);
	}

	updateClinicalStatusNote(resource) {
		return super.update(this.base + `/{id}/clinical-status/note`, resource);
	}
}

export default FacilityOrderTemplateRouteService;
